function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M19.1 0h3.8c.6 0 1.1.5 1.1 1.1v3.8c0 .6-.5 1.1-1.1 1.1h-3.8c-.6 0-1.1-.5-1.1-1.1V1.1c0-.6.5-1.1 1.1-1.1zM1.1 15H6c1-5.3 4.8-8.3 9-8.7V1.2c0-.7-.5-1.2-1.1-1.2H1.1C.5 0 0 .5 0 1.1v12.8c0 .6.5 1.1 1.1 1.1zM1.1 18h3.8c.6 0 1.1.5 1.1 1.1v3.8c0 .6-.5 1.1-1.1 1.1H1.1C.5 24 0 23.5 0 22.9v-3.8c0-.6.5-1.1 1.1-1.1zM23.9 16.1z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M23.8 17s-.8-.9-1.2-1.8-2.3-1.2-1.7-.7-.7 1-1.5 1.3c-.5.2-1.3-.4-1.6-.8.2 1 .2 5 .3 5.3.1.3-.2 1.9-.3 2.2s-1.9 0-1.9 0v-1.9c0-.8-.4-1.3-.7-1.4s-1.8-.3-2.3-.6-.7-2.2-.5-3.1 2-.9 2-.9l.9.1.9.1.7-.5-.1-.7-.8-.2-1 .5-.2-1 1-.9.8-.7 1.2.7 3.9-1.3c.7.7 1.2 1.4 1.5 2.1-.2-.5-.5-.9-.7-1.3-1.4-2-3.8-3.2-6.4-3.2-4.4 0-7.9 3.5-7.9 7.9 0 2.6 1.3 4.9 3.2 6.3 1.3 1 3 1.6 4.7 1.6 1.8 0 3.4-.6 4.7-1.6.6-.5 1.2-1 1.7-1.7.8-1.1 1.4-2.5 1.5-4-.2.1-.2.2-.2.2zm-8.6-5.5l-.5.5-.3-.9.6-.8.2 1.2zm-.3-3.2L14 10l-1.7 1.4-1.2-1.4c1.6-1.4 3.8-1.7 3.8-1.7zm-4.3 6l-.2.7s0 .8-.4.7-.6-.4-.7-.5-.1-1.2-.1-1.2l-.8.1s.3-1.6 1.6-2.7l1.1 1.4.6-.4 1.1.2-.6.9-1.6.8z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default SvgComponent;